import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Login from './components/Login';
import Register from './components/Register';
import Crops from './components/Crops';

function App() {
  const [token, setToken] = useState(localStorage.getItem('token-axarquia'));

  useEffect(() => {
    const checkToken = () => {
      const token = localStorage.getItem('token-axarquia');
      if (token) {
        try {
          const payload = JSON.parse(atob(token.split('.')[1])); // Decodifica el payload del JWT
          console.log(payload.exp)
          //const payload = 1740471108
          if (payload.exp * 1000 < Date.now()) {
            console.warn("Token expirado, eliminando...");
            localStorage.removeItem('token-axarquia'); // Borra el token expirado
            setToken(null)
          }
        } catch (err) {
          console.error("Error al decodificar el token:", err);
          localStorage.removeItem('token-axarquia'); // Borra el token si está corrupto
        }
      }
    };

    checkToken();
  }, []);
  
  //   useEffect(() => {
  //   const script = document.createElement("script");
  //   script.async = true;
  //   script.src = "https://www.googletagmanager.com/gtag/js?id=G-RXM6Z9M54K";
  //   document.head.appendChild(script);

  //   window.dataLayer = window.dataLayer || [];
  //   function gtag(){ dataLayer.push(arguments); }
  //   gtag('js', new Date());
  //   gtag('config', 'G-RXM6Z9M54K');
  // }, []);

  const handleLogin = (newToken) => {
    setToken(newToken);
    localStorage.setItem('token-axarquia', newToken);
  };

  const handleLogout = () => {
    setToken(null);
    localStorage.removeItem('token-axarquia');
  };

  return (
    <Router>
      <div className="App">
        {token ? (
          //<Crops token={token} onLogout={handleLogout} />
          <Crops token={token} onLogout={handleLogout} />
        ) : (
          <Routes>
            <Route path="/login" element={<Login onLogin={handleLogin} />} />
            <Route path="/register" element={<Register />} />
            <Route path="/" element={<Navigate to="/login" />} />
          </Routes>
        )}
      </div>
    </Router>
  );
}

export default App;
